import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import styles from './value-label.css'

const ValueLabel = ({ align, children, label, size, theme, value }) => {
  const className = `value-label-${align}`
  const valueClass = `value value-${size} theme-${theme}`

  return (
    <div styleName={className}>
      {!_.isNil(value) ? <p styleName={valueClass}>{value}</p> : null}
      {label && <p styleName="label">{label}</p>}
      {children}
    </div>
  )
}

ValueLabel.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.any,
  label: PropTypes.any,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  theme: PropTypes.oneOf(['light', 'dark']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

ValueLabel.defaultProps = {
  align: 'left',
  size: 'medium',
  theme: 'light',
}

export default CSSModules(ValueLabel, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/value-label/value-label.js
 **/